import { render, staticRenderFns } from "./URegisterInfo.vue?vue&type=template&id=0e848c8e&scoped=true&"
import script from "./URegisterInfo.vue?vue&type=script&lang=ts&"
export * from "./URegisterInfo.vue?vue&type=script&lang=ts&"
import style0 from "./URegisterInfo.vue?vue&type=style&index=0&id=0e848c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e848c8e",
  null
  
)

export default component.exports